import { filter, Observable, switchMap } from 'rxjs';
import {
  GetDeviceActions,
  GetDeviceActionTypes,
  getDeviceFailed,
  GetDeviceRequest,
  getDeviceSucceeded,
} from './action';
import { setAuthenticatedClient } from '../../../../client/graphql';
import { getDeviceQuery } from './getDeviceQuery';

export function getDeviceEpic(action$): Observable<GetDeviceActionTypes> {
  return action$.pipe(
    filter((action: GetDeviceActions) => action.type === GetDeviceActionTypes.GET_DEVICE_REQUEST),
    switchMap((action: GetDeviceRequest) =>
      getDevice({ id: action.id }).then(getDeviceSucceeded).catch(getDeviceFailed),
    ),
  );
}

export async function getDevice(input) {
  console.log('📦 GetDevice: Получение устройства');

  const graphQLClient = await setAuthenticatedClient();
  console.log('📦 GraphQL Client:', graphQLClient ? 'OK' : 'NULL');
  try {
    const {
      data: { getDevice: device },
    } = await graphQLClient.query({
      query: getDeviceQuery,
      variables: { input },
      fetchPolicy: 'cache-first',
    });
    console.log('Получаем уствройство:', JSON.stringify(device, null, 2));

    return device;
  } catch (e) {
    console.error('❌ Полная ошибка:', e);
    console.error('❌ GraphQL errors:', JSON.stringify(e.graphQLErrors, null, 2));

    // Выводим каждую ошибку отдельно
    if (e.graphQLErrors && e.graphQLErrors.length > 0) {
      e.graphQLErrors.forEach((err, index) => {
        console.error(`❌ Ошибка ${index + 1}:`, err.message);
        console.error(`   Path:`, err.path);
        console.error(`   Extensions:`, err.extensions);
      });
    }

    throw new Error('Failed to get device');
  }
}
